<template>
    <el-drawer title="情绪检测结果" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <h3 v-if="data" class="info">文件：{{ data.name }}</h3>
            <div class="page-list-box">
                <el-table :data="dataList.slice((currentPage - 1) * pagesize, currentPage * pagesize )"  border style="width: 100%"  size="small" stripe  v-loading="listLoading">
                    <el-table-column prop="type" label="语句"></el-table-column>
                    <el-table-column prop="words" label="情绪"></el-table-column>
                </el-table>
            </div>
           <!-- <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div> -->
			<div v-if="dataList && dataList.length > 0" class="page-pagination-box">
				<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="pagesize"
					  layout="total, sizes, prev, pager, next, jumper"
					  :total="dataList.length">
				</el-pagination>
			</div>
        </div>

        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>

export default {
    data() {
        return {
            drawerShow: false,
            listLoading: false,
            data: null,
            dataList: [],
            currentPage: 1, //初始页
            pagesize: 10, // 每页的数据
			id:''
        }
    },
    methods: {
        close() {
            this.dataList = [];
            this.data = null;
            this.drawerShow = false;
            this.listLoading = false;
            this.pagesize = 10
        },
        show(id) {
            this.id = id;
            this.getDataList();
            this.drawerShow = true;
        },
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/document/emotionResult",
                method: "POST",
                params: {id:this.id },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.list || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        handleSizeChange (size) {
        	this.pagesize = size;
        },
        handleCurrentChange (currentPage) {
        	this.currentPage = currentPage;
        },
       
    }
}
</script>

<style lang="scss" scoped>
</style>